import { formatCurrency } from "util/format";
import moment from "moment";

export const ColumnsCashFlowLate = [
  {
    title: "Data",
    dataIndex: "dueDate",
    render: (text) => {
      let dateString = moment(text).format("DD/MM/YYYY");
      return dateString;
    },
  },
  {
    title: "Cliente",
    dataIndex: "customer",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Tipo",
    dataIndex: "type",
  },
  {
    title: "Valor",
    dataIndex: "amount",
    render: (text) => {
      return formatCurrency(text);
    },
  },
];

